export const useGlobalStore = defineStore('global-context', () => {
  const isLoading = ref(false)
  const isFullPageLoadingShown = ref(false)

  const rootDynamicComponent = shallowRef(null)
  const shouldRootDynamicComponentShow = ref(false)
  const rootDynamicComponentOption = ref({})

  async function executeWithLoading<T>(fn: () => Promise<T>) {
    isLoading.value = true
    try {
      return await fn()
    } finally {
      isLoading.value = false
    }
  }

  function setShouldRootDynamicComponentShow(bool: boolean) {
    shouldRootDynamicComponentShow.value = !!bool
  }
  function setRootDynamicComponent(component: any) {
    rootDynamicComponent.value = component
  }
  function setRootDynamicComponentOption(option: any) {
    rootDynamicComponentOption.value = option || {}
  }

  return {
    isLoading,
    executeWithLoading,
    isFullPageLoadingShown,
    rootDynamicComponent,
    shouldRootDynamicComponentShow,
    rootDynamicComponentOption,
    setShouldRootDynamicComponentShow,
    setRootDynamicComponent,
    setRootDynamicComponentOption,
  }
})
